const t = {
  name: "SwedishKrona",
  dimensions: { width: 40, height: 40 },
  content: `
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_566_2372)">
<path d="M11.0054 11.0022H13.0054V24.1622L18.1654 19.0022H21.0054L15.9954 24.0022L21.0054 29.0022H18.1754L14.5854 25.4122L13.0054 27.0022L13.0054 29.0022H11.0054V11.0022Z" fill="currentColor"/>
<path d="M23.0054 19.0022V29.0022H25.0054V24.0022C25.0054 22.3445 26.3477 21.0022 28.0054 21.0022H29.0054V19.0022H28.0054C26.8796 19.0022 25.8409 19.3739 25.0054 20.0013V19.0022H23.0054Z" fill="currentColor"/>
<path d="M0.00537109 20.0022C0.00537109 8.9565 8.95968 0.00219727 20.0054 0.00219727C31.0511 0.00219727 40.0054 8.9565 40.0054 20.0022C40.0054 31.0479 31.0511 40.0022 20.0054 40.0022C8.95968 40.0022 0.00537109 31.0479 0.00537109 20.0022ZM20.0054 2.0022C10.0642 2.0022 2.00537 10.0611 2.00537 20.0022C2.00537 29.9433 10.0642 38.0022 20.0054 38.0022C29.9465 38.0022 38.0054 29.9433 38.0054 20.0022C38.0054 10.0611 29.9465 2.0022 20.0054 2.0022Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_566_2372">
<rect width="40" height="40" fill="white" transform="translate(0.00537109 0.00219727)"/>
</clipPath>
</defs>
</svg>
  `
};
export {
  t as SwedishKrona
};
